import { Component, ViewChild, ElementRef } from '@angular/core';


@Component({
  selector: 'app-debug-voice',
  templateUrl: './debug-voice.component.html',
  styleUrls: ['./debug-voice.component.scss'],
  standalone: false
})
export class DebugVoiceComponent {
  public first = true;
  public loading = true;

  @ViewChild('audioOutput', { static: true })
  audioOutput: ElementRef<HTMLAudioElement>;

  onFileReady(audio: Blob) {
    this.first = false;
    this.loading = true;
    this.setAudio(audio);
    this.loading = false;
  }

  setAudio(audio: Blob) {
    const uri = URL.createObjectURL(audio);
    this.audioOutput.nativeElement.src = uri;
  }

}
